(function () {
  var bar = document.querySelector('[data-yp-savebar]');
  var box = document.querySelector('[data-products]');
  if (!bar || !box) return;
  function fmt(c) {
    try { return theme.Currency.formatMoney(c, theme.settings.moneyFormat); } catch (e) { return '$' + (c / 100).toFixed(2); }
  }
  // Kit nudge (30 Sep 2026): show the cart's hidden nudge on the "In your
  // bag" heading line, so it costs no vertical space.
  function placeNudge() {
    var sect = box.closest('.cart-sect--items');
    var head = sect && sect.querySelector('.cart-sect__h');
    if (!head) return;
    var old = head.querySelector('.cart__kit-nudge');
    if (old) old.remove();
    var src = box.querySelector('[data-yp-kit-nudge]');
    var form = box.closest('.cart__drawer-form');
    if (form) form.classList.toggle('yp-kit-nudge-on', !!src);
    if (!src) { head.classList.remove('has-kit-nudge'); return; }
    var copy = src.cloneNode(true);
    copy.removeAttribute('data-yp-kit-nudge');
    head.appendChild(copy);
    head.classList.add('has-kit-nudge');
  }
  // One tap on the kit pill: add the tweezer as a kit item, let the kit code
  // sync pick the new tier, then rebuild the cart in place.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.cart-sect__h .cart__kit-nudge[data-variant]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    btn.disabled = true;
    btn.innerHTML = 'Adding\u2026';
    fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: parseInt(btn.getAttribute('data-variant'), 10), quantity: 1, properties: { _byob: 'true' } }] })
    }).then(function () {
      return (window.theme && theme.BYOBDiscountSync) ? theme.BYOBDiscountSync.sync() : null;
    }).catch(function () {}).then(function () {
      document.dispatchEvent(new CustomEvent('cart:build'));
      document.dispatchEvent(new CustomEvent('cart:updated'));
    });
  });
  function update() {
    placeNudge();
    var items = box.querySelector('.cart__items');
    var c = items ? parseInt(items.getAttribute('data-yp-saving'), 10) : 0;
    var pl = document.querySelector('[data-yp-paylater]');
    var sub = items ? parseInt(items.getAttribute('data-cart-subtotal'), 10) : 0;
    if (pl) {
      if (sub >= 3000 && sub <= 200000) {
        pl.querySelector('[data-yp-paylater-amt]').innerHTML = fmt(Math.ceil(sub / 4));
        pl.classList.remove('hide');
      } else {
        pl.classList.add('hide');
      }
    }
    if (c > 0) {
      var sale = parseInt(items.getAttribute('data-yp-sale'), 10) || 0;
      var code = parseInt(items.getAttribute('data-yp-code'), 10) || 0;
      var names = (items.getAttribute('data-yp-code-names') || '').replace(/,\s*$/, '') || 'discount';
      var kit = parseInt(items.getAttribute('data-yp-kit'), 10) || 0;
      var kitNames = items.getAttribute('data-yp-kit-names') || '';
      // Pink box (30 Sep 2026): line 1 is the total, line 2 names what made it.
      // Kit and order codes are the "extra" on top of any sale. Long codes
      // (Klaviyo unique ones) become "your code" so line 2 stays on one line.
      function nm(n) { n = String(n || '').split(',')[0].trim().toUpperCase(); return n && n.length <= 10 ? n : 'your code'; }
      var parts = [];
      if (sale > 0) parts.push(fmt(sale) + ' sale');
      if (kit > 0) parts.push((parts.length ? fmt(kit) + ' extra with ' : fmt(kit) + ' off with ') + nm(kitNames));
      if (code > 0) parts.push((parts.length ? fmt(code) + ' extra with ' : fmt(code) + ' off with ') + nm(names));
      var line2 = parts.length === 1 && sale > 0 ? fmt(sale) + ' off sale prices' : parts.join(' + ');
      bar.innerHTML = "You're saving <strong>" + fmt(c) + '</strong> in total' +
        (line2 ? '<span class="cart__savebar-parts">' + line2 + '</span>' : '');
      bar.classList.remove('hide');
    } else {
      bar.classList.add('hide');
    }
  }
  new MutationObserver(update).observe(box, { childList: true });
  update();
})();

/* The theme sizes the drawer as window height minus the header's own height,
   which ignores the announcement bar above it, so the bottom of the drawer
   (and the checkout button) ran off the screen on phones. This sizes it from
   where the header actually ends. */
(function () {
  var hw = document.getElementById('HeaderWrapper');
  if (!hw) return;
  function size() {
    var bottom = Math.max(hw.getBoundingClientRect().bottom, hw.offsetHeight);
    // Window height, not visualViewport: on iPhone the keyboard shrinks the
    // visual viewport, which shrank the drawer and showed the page under it
    // (Shirley, 30 Sep 2026).
    document.documentElement.style.setProperty('--maxDrawerHeight', Math.round(window.innerHeight - bottom) + 'px');
  }
  // Re-size the moment the drawer opens, not only on scroll or click, so a
  // drawer opened by script (the Build Your Own Kit button) is always sized
  // from where the header is now (30 Sep 2026).
  var drawer = document.getElementById('HeaderCart');
  if (drawer && window.MutationObserver) {
    new MutationObserver(function () { if (drawer.classList.contains('is-active')) size(); })
      .observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }
  if (window.theme) theme.sizeDrawer = size;
  ['resize', 'scroll', 'orientationchange'].forEach(function (ev) { window.addEventListener(ev, size, { passive: true }); });
  document.addEventListener('click', function () { setTimeout(size, 50); setTimeout(size, 400); }, true);
  size();
})();
